import script from "./RegionSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionSelector.vue?vue&type=script&setup=true&lang=js"

import "./RegionSelector.vue?vue&type=style&index=0&id=6d9fa262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9fa262"]])

export default __exports__